"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var routeIndex_exports = {};
__export(routeIndex_exports, {
  createRouteIndex: () => createRouteIndex,
  getRoutePaths: () => getRoutePaths
});
module.exports = __toCommonJS(routeIndex_exports);
var import_micromatch = __toESM(require("micromatch"), 1);
var import_path = __toESM(require("path"), 1);
var import_globDir = require("./globDir");
var import_routeFileWatch = require("./routeFileWatch");
function getRoutePaths(routerRoot, ignoredRouteFiles) {
  var routePaths = (0, import_globDir.globDir)(routerRoot).filter(function(routePath) {
    return !routePath.endsWith(".d.ts");
  });
  if (!(ignoredRouteFiles === null || ignoredRouteFiles === void 0 ? void 0 : ignoredRouteFiles.length)) return routePaths;
  return import_micromatch.default.not(routePaths, ignoredRouteFiles, {
    matchBase: true
  });
}
function createRouteIndex(param) {
  var { routerRoot, ignoredRouteFiles } = param;
  var absoluteRouterRoot = import_path.default.resolve(routerRoot);
  var routePaths = new Set(getRoutePaths(absoluteRouterRoot, ignoredRouteFiles));
  return {
    getPaths() {
      return [
        ...routePaths
      ].sort();
    },
    update(event, filePath) {
      if (event !== "add" && event !== "delete" && event !== "unlink") return false;
      if (!(0, import_routeFileWatch.isPathInsideDirectory)(filePath, absoluteRouterRoot)) return false;
      if (!(0, import_routeFileWatch.isRouteFilePath)(filePath)) return false;
      var relativePath = import_path.default.relative(absoluteRouterRoot, import_path.default.resolve(filePath)).replaceAll("\\", "/");
      var routePath = `./${relativePath}`;
      if ((ignoredRouteFiles === null || ignoredRouteFiles === void 0 ? void 0 : ignoredRouteFiles.length) && import_micromatch.default.isMatch(routePath, ignoredRouteFiles, {
        matchBase: true
      })) {
        return false;
      }
      if (event === "add") {
        var size = routePaths.size;
        routePaths.add(routePath);
        return routePaths.size !== size;
      }
      return routePaths.delete(routePath);
    }
  };
}
//# sourceMappingURL=routeIndex.js.map
